<div class="modal-header">
  <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body" (keyup.esc)="cancel()">
  @if (dialogPrompt) {
    <div class="mb-2">{{ dialogPrompt }}</div>
  }
  <div>
    <dx-date-box #dateComponent [(value)]="dialogValue" valueChangeEvent="input" [disabled]="processing"></dx-date-box>
  </div>
  @if (!!dialogMessage) {
    <div class="mt-3">
      {{ dialogMessage }}
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
  <button type="button" class="btn btn-light" (click)="cancel()" [disabled]="processing">Cancel</button>
</div>
